import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-street-2",
  "use": "icon-si-glyph-street-2-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-street-2\" id=\"icon-si-glyph-street-2\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1146</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M17.02,14.046 L17.02,1.046 L1.02,1.046 L1.02,14.046 L17.02,14.046 L17.02,14.046 Z M14,6.953 L16,6.953 L16,7.953 L14,7.953 L14,6.953 L14,6.953 Z M9,1.992 L13,1.992 L13,4.02 L9,4.02 L9,1.992 L9,1.992 Z M9,5 L13.021,5 L13.021,7 L9,7 L9,5 L9,5 Z M9,8 L13.021,8 L13.021,10 L9,10 L9,8 L9,8 Z M9,10.958 L13,10.958 L13,12.958 L9,12.958 L9,10.958 L9,10.958 Z M5,6.953 L7,6.953 L7,8 L5,8 L5,6.953 L5,6.953 Z M2,6.953 L4,6.953 L4,8 L2,8 L2,6.953 L2,6.953 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-street-2.svg
// module id = IgMs
// module chunks = 62